import { useWatch } from 'react-hook-form';

import { type QuizQuoteFormValues } from '../utils/quizQuote.schema';
import {
  isTrialEndDiscountApplicable,
  type TrialEndQuoteDiscount,
} from '../utils/quoteCalculator';

/**
 * 지금 선택한 조건에 체험 종료 할인이 실제로 붙는지. 기간 초과분은 정가여도 할인
 * 태그·안내 카드를 유지한다(Figma 29113:6288).
 */
export function useApplicableTrialEndDiscount(
  discount: TrialEndQuoteDiscount | null,
): TrialEndQuoteDiscount | null {
  const values = useWatch<QuizQuoteFormValues>() as QuizQuoteFormValues;

  return isTrialEndDiscountApplicable(discount, values) ? discount : null;
}
